module.exports = __webpack_public_path__ + "static/img/interactionLive02.8f07838.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/interactionLive02.png
// module id = Q8OH
// module chunks = 0